export default "__VITE_ASSET__b94e4713__"